import UAParser from 'ua-parser-js';
import { getGlobalLogger } from '@zg-rentals/logger-browser';
import { getIsNative } from './userAgent';
import configureStore from '../../shared/configureStore';

const logger = getGlobalLogger('ra-landlord-web-ssr');

const initialState = (window as any).__INITIAL_STATE__;

const store = configureStore(initialState);

const parsedUserAgent = new UAParser(navigator.userAgent);

const logObject = {
  name: __filename,
  browser: parsedUserAgent.getBrowser().name,
  browserVersion: parsedUserAgent.getBrowser().version,
  operatingSystem: parsedUserAgent.getOS(),
  isWebView: getIsNative(navigator.userAgent),
  userId: store.getState().user.userToken,
};

const log = {
  info: (message: string, ...args: Array<any>) => {
    logger.info(logObject, message, ...args);
  },
  error: (message: string, ...args: Array<any>) => {
    logger.error(logObject, message, ...args);
  },
  debug: (message: string, ...args: Array<any>) => {
    logger.debug(logObject, message, ...args);
  },
  warn: (message: string, ...args: Array<any>) => {
    logger.warn(logObject, message, ...args);
  },
  trace: (message: string, ...args: Array<any>) => {
    logger.trace(logObject, message, ...args);
  },
  fatal: (message: string, ...args: Array<any>) => {
    logger.fatal(logObject, message, ...args);
  },
  silent: (message: string, ...args: Array<any>) => {
    logger.silent(logObject, message, ...args);
  },
  level: logger.level,
  child: (...args: Array<any>) => (logger.child as any)(...args),
};

(global as any).log = log;
export default log;
